import React from 'react';

import { BaseTextInputProps } from '../shared-types';
import BaseInput from '../BaseInput/BaseInput';
import InputControl from '../InputControl/InputControl';
import { noop } from '../utils';

export type Props = BaseTextInputProps;

const TextInput = (props: Props): JSX.Element => {
  const {
    label,
    error,
    required,
    hint,
    eventId,
    type = 'text',
    onChange = noop,
    onHintToggle = noop,
    ...inputProps
  } = props;

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange(event.target?.value || '');
  };

  return (
    <InputControl
      id={`TextInput-${label}`}
      label={label}
      errorMessage={error}
      required={required}
      hint={hint}
      onHintToggle={onHintToggle}
      eventId={eventId}
    >
      <BaseInput
        {...inputProps}
        type={type}
        label={label}
        componentName="TextInput"
        onChange={handleChange}
      />
    </InputControl>
  );
};

export default TextInput;
